import "./Courses.css";

import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import {
  getOverviewCoursesThunk,
  setCurrentCourseThunk,
} from "../../../store/slices/userThunks";

import { CourseOverview } from "../../../model/model";
import Header from "../../../components/Header";
import React from "react";
import ThemeIcon from "../../../components/custom-icons/ThemeIcon";
import { klassi } from "../../../utils/utils";
import { useNavigate } from "react-router-dom";

export default function Courses() {
  const courses: CourseOverview[] | null = useAppSelector(
    (state: RootState) => state.user.coursesOverview
  );
  const user = useAppSelector((state: RootState) => state.user.user);
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getOverviewCoursesThunk());
  }, [dispatch]);

  if (!courses || !user) {
    return <div className="loa-page">Loading...</div>;
  }

  const onCourseClick = (course: CourseOverview) => {
    console.log("onCourseClick", course);
    dispatch(setCurrentCourseThunk({ email: user.email, course: course.uid }))
      .unwrap()
      .then(() => {
        navigate("/lessons");
      });
  };

  return (
    <div className="loa-page courses-page">
      <Header>
        <div />
        <h3 className="courses-title">Courses for {user.name}</h3>
        <ThemeIcon />
      </Header>
      <div className="courses-container">
        <div className="courses-list">
          {courses.map((course) => {
            const klass = klassi(
              { expired: course.expired, active: !course.expired },
              "course-tile"
            );

            return (
              <div
                className={klass}
                onClick={() => onCourseClick(course)}
                key={course.uid}
              >
                <div className="course-image-wrapper">
                  <img src={course.image} alt="Course" />
                </div>
                <div className="course-content-wrapper">
                  <h4 className="course-title">{course.name}</h4>
                  <div className="expires">
                    {course.expired ? "Expired" : `Expires ${course.expires}`}
                  </div>
                </div>
                <div className="course-progress-wrapper">
                  <div
                    className="progress-bar"
                    style={{ width: `${course.progress}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
